import { render, staticRenderFns } from "./CoachProfiles.vue?vue&type=template&id=1464fd80&"
import script from "./CoachProfiles.vue?vue&type=script&setup=true&lang=js&"
export * from "./CoachProfiles.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CoachProfiles.vue?vue&type=style&index=0&id=1464fd80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports